/** Decides whether a url is to the current domain or a different one.
 * Useful for deciding if we can use a <Link> or we need an <a> */
export function urlIsSameDomain(url: string): boolean {
  return url.startsWith("/"); // Not actually correct, but good enough for now
}

export function urlIsDocsLink(url: string): boolean {
  return url.includes("docs.chalk.ai");
}

export function downloadURL(url: string) {
  const link = document.createElement("a");
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function downloadBlob(content: BlobPart, filename: string, contentType: string) {
  const blob = new Blob([content], { type: contentType });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
